export const UNKNOWN_ERROR = {
	title: "Unbekannter Fehler",
	message: "Bei der Kommunikation mit dem Server ist ein Fehler aufgetreten. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.",
}